import { render, staticRenderFns } from "./FormMultipleRadioButton.vue?vue&type=template&id=1643bd59&scoped=true"
import script from "./FormMultipleRadioButton.vue?vue&type=script&lang=js"
export * from "./FormMultipleRadioButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1643bd59",
  null
  
)

export default component.exports